// super-excalidraw: drop-in replacement for upstream OverwriteConfirmState.ts.
//
// Upstream renders a "Replace my content" confirm modal (with "Save to disk"
// and "Export as image" backup actions) whenever the user opens a new diagram
// over a canvas that already has elements — via the menu's Open item or via
// a `#json=ID,KEY` link from our dashboard.
//
// In this fork the previous diagram is already being auto-saved to the server
// on every edit (and `MyDiagramsDialog.onOpen` force-flushes that autosave
// before navigating away), so the backup actions are redundant. We bypass the
// modal entirely by short-circuiting `openConfirmModal` to resolve `true`.
//
// We keep the type, the atom (always `active: false`), and the function
// signature so `LayerUI.tsx`, `OverwriteConfirm.tsx`, and every existing
// caller still type-check and compile against an unmodified upstream surface.

import { atom } from "../../editor-jotai";

import type React from "react";

export type OverwriteConfirmState =
  | {
      active: true;
      title: string;
      description: React.ReactNode;
      actionLabel: string;
      color: "danger" | "warning";

      onClose: () => void;
      onConfirm: () => void;
      onReject: () => void;
    }
  | { active: false };

export const overwriteConfirmStateAtom = atom<OverwriteConfirmState>({
  active: false,
});

export async function openConfirmModal(_opts: {
  title: string;
  description: React.ReactNode;
  actionLabel: string;
  color: "danger" | "warning";
}) {
  return true;
}
